import Icon from "@mui/icons-material/GridOn";
import ItsdataList from "./ItsdataList";
import ItsdataShow from "./show/ItsdataShow";

export default {
  list: ItsdataList,
  show: ItsdataShow,
  icon: Icon,
  label: "ITS Data",
  options: { label: "ITS Data" },
  name: "itsdata",
};
